import { useState, useCallback } from "react";
import { VmCostAnalysisService } from "../../../application/services/aiServices/vmCostAnalysisService";

const vmCostAnalysisService = new VmCostAnalysisService();

export const useVmCostAnalysis = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [vmCostAnalysis, setVmCostAnalysis] = useState(null);
  const [allVmCostAnalyses, setAllVmCostAnalyses] = useState([]);

  const getVmCostAnalysis = useCallback(async (vmId) => {
    setLoading(true);
    setError(null);
    try {
      const result = await vmCostAnalysisService.getVmCostAnalysis(vmId);
      if (result.success) {
        setVmCostAnalysis(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const getAllVmCostAnalyses = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await vmCostAnalysisService.getAllVmCostAnalyses();
      if (result.success) {
        setAllVmCostAnalyses(result.data);
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  const analyzeAllVmCosts = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const result = await vmCostAnalysisService.analyzeAllVmCosts();
      if (result.success) {
        return { success: true, data: result.data };
      } else {
        setError(result.message);
        return { success: false, message: result.message };
      }
    } catch (error) {
      setError(error.message);
      return { success: false, message: error.message };
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    getVmCostAnalysis,
    getAllVmCostAnalyses,
    analyzeAllVmCosts,
    vmCostAnalysis,
    allVmCostAnalyses,
    loading,
    error,
  };
};